import React, { useEffect } from "react";
import $ from "jquery";
import * as ScrollMagic from "scrollmagic";
import { TweenMax, TimelineMax, gsap } from "gsap";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import { event } from "../../meta/event";
import style from "./brandevent.module.css";

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax, gsap);

export default function BrandEvent() {
  useEffect(() => {
    if (document.documentElement.clientWidth > 768) {
      TweenMax.defaultOverwrite = false;
      let controller = new ScrollMagic.Controller();
      let sections = document.querySelectorAll("section");
      let tl = new TimelineMax();
      let offset = window.innerHeight;
      for (let i = 1; i < sections.length; i++) {
        tl.from(
          sections[i],
          1,
          {
            xPercent: 100,
            ease: "linear.easeNone",
          },
          "+=1"
        );
      }
      new ScrollMagic.Scene({
        triggerElement: "#pinMaster",
        triggerHook: "onLeave",
        duration: "400%",
      })
        .setPin("#pinMaster")
        .setTween(tl)
        .addTo(controller);
      $("section").each(function (i) {
        let picOverlay = $(this).find(".overlay");
        let animateIn = new TimelineMax();
        animateIn.fromTo(
          picOverlay,
          0.8,
          {
            skewX: 0,
            scale: 3,
          },
          {
            skewX: 0,
            xPercent: 103,
            transformOrigin: "0 100%",
            ease: "power4.easeInOut",
          },
          "-=1"
        );
        new ScrollMagic.Scene({
          triggerElement: "#pinMaster",
          triggerHook: 0,
          offset: i * offset,
        })
          .setTween(animateIn)
          .addTo(controller);
      });
    }
  }, []);

  return (
    <div id="work">
      <div id="pinMaster">
        <div id="pinContainer" className={style.mobileContainer}>
          {Object.values(event).map((item, i) => (
            <section
              key={item.backgroundColor}
              className={`${style.panel}`}
              style={{ background: `${item.backgroundColor}` }}
            >
              <div className="h-100 d-flex flex-column justify-content-lg-center">
                <div className="row justify-content-lg-center align-items-lg-center m-0">
                  <div className="col-lg-7 p-0">
                    <div className={style.box}>
                      <div className={style.imgWrapper}>
                        <img
                          width="640"
                          height="360"
                          className={`lazyload ${style.portfolioImg}`}
                          alt={item.desc}
                          data-src={item.image}
                        />
                        <div
                          style={{ visibility: i === 0 ? "hidden" : "visible" }}
                          className={`overlay ${style.overlayStyle}`}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className={`col-lg-5 d-flex ${style.h100}`}>
                    <div className={`row w-100 ${style.projectDesc}`}>
                      <div className="col-lg-12 align-self-lg-start mobile-display"></div>
                      <div
                        className={`${style.titleMargin} col-lg-12 align-self-lg-center`}
                      >
                        <h4 className={style.subH}>
                          <span className="did">{item.title}</span>
                        </h4>
                        <h3>{item.subTitle}</h3>
                      </div>
                      <div
                        className={`col-lg-12 align-self-lg-end ${style.wordBottom}`}
                      >
                        <a href={item.linkAddress}>{item.linkTitle}</a>
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
